import styled, { css } from 'styled-components';
import { grayBgSubtle, neutralWhite, navyDeep, navyLight, navyDeepest } from '../../../themes/colors';
import { LinkButton } from '../../../button/LinkButton';

export const ActionItemsWrapper = styled.div<{ $inline: boolean }>`
	display: flex;
	flex-direction: column;
    padding: 0;
    border-radius: 4px;
    gap: 8px;
    background-color: transparent;
    ${({ $inline }) => $inline === true && css`
        border: 1px solid ${grayBgSubtle};
        background-color: ${neutralWhite};
        padding: 12px;
    `}
`;

export const ActionHeader = styled.p`
	font-size: 14px;
	font-weight: 500;
	color: ${navyDeep};
	font-family: "Red Hat Display", sans-serif;
	margin: 0;
`;

export const ActionItemsList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
`;

export const ActionItem = styled.div<{ $inline: boolean }>`
	display: flex;
	flex-direction: column;
	gap: 12px;
    box-shadow: 0 2px 5px 0 rgba(32, 56, 87, 0.08);
    padding: 12px;
    background-color: ${neutralWhite};
        ${({ $inline }) => $inline === true && css`
            border: 1px solid ${grayBgSubtle};
            padding: 8px;
            gap: 8px;
            box-shadow: none;
            margin-bottom: 0;
            background-color: transparent;
        `}
    border-radius: 4px;
`;

export const ActionItemsHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
`;

export const ActionItemsContent = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;
`;

export const Text = styled.p<{ $inline: boolean }>`
	font-size: 14px;
	font-weight: 500;
	font-family: "Red Hat Display", sans-serif;
	margin: 0;
    color: ${navyLight};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    ${({ $inline }) => $inline === false && css`
        font-size: 16px;
        color: ${navyDeepest};
    `}
`;

export const ActionItemsContentHeader = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
    width: 100%;
`;

export const StatusLabelWrapper = styled.div`
    flex-shrink: 0;
    white-space: nowrap;
`;

export const StyledLinkButton = styled(LinkButton)`
    min-height: 24px;
`;

export const EmptyWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 12px;
`;
